import React from 'react';
import { useNavigate } from 'react-router-dom';

const SecureCodeReportPage = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <div className="flex justify-center">
        <div className="w-full max-w-6xl px-2">
          <div className="bg-white rounded shadow border border-gray-200">
            {/* Header */}
            <div className="bg-gray-600 px-5 py-3 flex items-center justify-between">
              <span className="text-2xl text-white font-normal capitalize">
                Secure Code Report
              </span>
              <button 
                onClick={function() { navigate(-1); }}
                className="bg-blue-500 text-white px-4 py-1 hover:bg-blue-600"
                style={{ borderRadius: 0 }}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecureCodeReportPage;